import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import { Modal } from "react-bootstrap";
import { storeUserData } from "./utils/auth";
import CryptoJS from "crypto-js";
import authService from "./utils/authService";
import { Spinner } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import "./Login.css";
interface UserProfile {
  name: string;
  email: string;
}

export default function Login() {
  const navigate = useNavigate();
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [user, setUser] = useState<any | null>(null);
  const [loading, setisLoading] = useState<boolean>(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [modalNewMessage, setModalNewMessage] = useState<string>("");
  const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
  const [recaptchaVerified, setRecaptchaVerified] = useState<boolean>(false);
  let people_id: string = "";
  
  // Check if reCAPTCHA is enabled via environment variable
  const isRecaptchaEnabled = process.env.REACT_APP_RECAPTCHA === 'true';
  // reCAPTCHA v2 callback functions
  const onRecaptchaChange = (token: string | null): void => {
    if (token) {
      setRecaptchaVerified(true);
    } else {
      setRecaptchaVerified(false);
    }
  };

  const onRecaptchaExpired = (): void => {
    setRecaptchaVerified(false);
  };

  const onRecaptchaError = (): void => {
    setRecaptchaVerified(false);
    setAlertMessage('reCAPTCHA verification failed. Please try again.');
    setShowAlert(true);
  };

  // Reset reCAPTCHA
  const resetRecaptcha = (): void => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
    setRecaptchaVerified(false);
  };

  const handleLogin = useGoogleLogin({
    onSuccess: (response) => {
      if (isRecaptchaEnabled && !recaptchaVerified) {
        setAlertMessage("Please complete the reCAPTCHA verification.");
        setShowAlert(true);
        return;
      }
      setUser(response);
    },
    onError: (error) => {
      console.error("Login Failed:", error);
      setAlertMessage("Login Failed");
      setShowAlert(true);
    },
  });

  useEffect(() => {
    if (!user) return;

    const fetchUserProfile = async () => {
      try {
        const response = await axios.get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`
        );
        const { name, email } = response.data;
        sessionStorage.setItem("Name", name);
        sessionStorage.setItem("Email", email);
        people_id = response.data.id;
        setisLoading(true);
        const json = {
          email: CryptoJS.enc.Utf8.parse(email).toString(),
          access_token: CryptoJS.enc.Utf8.parse(user.access_token).toString(),
        };
        const userData = await authService.post("/suite/login/", json);
        const data = userData.data;

        if (data.exists) {
          // Store encrypted user data
          storeUserData(data);

          authService.post('/suite/update-suite-user-people-id', {
            user_id: data.Id,
            people_id: people_id
          })

          const userType = data.Type;
          if (userType.length === 1) {
            if (userType[0] === "AD") {
              navigate("/admin/courses");
              sessionStorage.setItem("Admin", "True");
            } else if (userType[0] === "TR") {
              navigate("/trainer/reports");
              sessionStorage.setItem("Trainer", "True");
            } else if (userType[0] === "CO") {
              navigate("/coordinator/filter-page");
              sessionStorage.setItem("Coordinator", "True");
            } else if (userType[0] === "SC") {
              navigate("/coordinator/filter-page");
              sessionStorage.setItem("Coordinator", "True");
              sessionStorage.setItem("SC", "True");
            } else if (userType[0] === "PO") {
              navigate("/placement-officer/company");
              sessionStorage.setItem("PO", "True");
            }
          } else {
            navigate("/dashboard", { state: { data: userType } });
          }
        } else {
          setShowUpdateModal(true);
          setModalNewMessage("User not found. Please login again.");
        }
      } catch (error) {
        setisLoading(false);
        
        // Reset reCAPTCHA on error (only if enabled)
        if (isRecaptchaEnabled) {
          resetRecaptcha();
        }
        
        setAlertMessage("Login Failed");
        setShowAlert(true);
        console.error("Error fetching user profile data:", error);
      }
      setisLoading(false);
    };

    fetchUserProfile();
  }, [user, navigate]);

  return (
    <div className="login container-fluid h-100 d-flex align-items-center justify-content-center">
      <div className="row w-100 justify-content-center">
        <div className="col-12 col-lg-8 d-flex align-items-center justify-content-center">
          <div className="">
            <span
              className="block text-start fw-bolder"
              style={{ color: "#fff", fontSize: "60px" }}
            >
              Exskilence
            </span>
            <p
              className="ps-5 text-start mb-3"
              style={{
                background: "linear-gradient(to right, #f5d547, #48e28f)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: "bold",
                fontStyle: "italic",
                fontSize: "24px",
              }}
            >
              <i>...Because Opportunity is a Right</i>
            </p>
            <div
              style={{ textAlign: "left", maxWidth: "600px", margin: "0 auto" }}
            >
              <p
                style={{
                  fontSize: "18px",
                  lineHeight: "1.8",
                  marginBottom: "1.5rem",
                  color: "#fff",
                }}
              >
                We are a Social Enterprise focused on providing Skilling and
                Placement Assistance to undergraduate students, from Computer
                Science Engineering and related streams, particularly from Tier
                2 and Tier 3 colleges.
              </p>
              <p
                style={{
                  fontSize: "18px",
                  lineHeight: "1.8",
                  color: "#fff",
                }}
              >
                At Exskilence, we are on a mission to empower individuals,
                transform careers, and unlock potential. We believe that quality
                tech education and real-world experience should be within
                everyone's reach, regardless of their background.
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-4 d-flex justify-content-center align-items-center px-3 py-4">
          <div
            className="card"
            style={{
              border: "none",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              borderRadius: "12px",
              maxWidth: "400px",
              width: "100%",
            }}
          >
            <div className="card-body p-4 d-flex flex-column align-items-center justify-content-center">
              <h4
                className="text-center mb-4"
                style={{ color: "#333", fontWeight: "600" }}
              >
                Login with your Google account
              </h4>
              <div className="text-center w-100">
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner color="#6f42c1" size="sm" className="me-2" />{" "}
                    Signing in...
                  </div>
                ) : (
                  <div className="d-flex flex-column align-items-center">
                    {isRecaptchaEnabled && process.env.REACT_APP_RECAPTCHA_SITE_KEY ? (
                      <div className="mb-3 d-flex justify-content-center">
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                          onChange={onRecaptchaChange}
                          onExpired={onRecaptchaExpired}
                          onErrored={onRecaptchaError}
                        />
                      </div>
                    ) : null}
                    <button
                      onClick={() => handleLogin()}
                      disabled={isRecaptchaEnabled ? !recaptchaVerified : false}
                      className="btn w-100"
                      style={{
                        backgroundColor: (isRecaptchaEnabled ? recaptchaVerified : true) ? '#4168a3' : '#6c757d',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        fontWeight: '500',
                        fontSize: '16px',
                        cursor: (isRecaptchaEnabled ? recaptchaVerified : true) ? 'pointer' : 'not-allowed'
                      }}
                    >
                      Sign in with Google
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalNewMessage}</Modal.Body>
      </Modal>
      <Modal show={showAlert} onHide={() => setShowAlert(false)} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton className='bg-primary'>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>{alertMessage}</Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={() => setShowAlert(false)}>Okay</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}